// extracted by mini-css-extract-plugin
module.exports = {"edit-event-button":"EditEventButton_edit-event-button__fYpfV","full-width":"EditEventButton_full-width__0Rr7n"};